import script from "./BusinessVerifyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessVerifyModal.vue?vue&type=script&setup=true&lang=js"

import "./BusinessVerifyModal.vue?vue&type=style&index=0&id=6208830c&lang=less"

const __exports__ = script;

export default __exports__